<template>
  <div>
    <div class="page-header">
      <div class="page-header-left">
        <ol class="breadcrumb ml-0">
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'welcome' }">
              <feather type="home" />
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'vendorManagementDashboard' }">
              {{ $t('companyFormAdminView.vendorManagement') }}
            </router-link>
          </li>
          <li class="breadcrumb-item">
            {{ $t('companyFormAdminView.tdarkDyrlndirmFormalar') }}
          </li>
        </ol>
      </div>
      <h4 class="my-3">
        {{ $t('companyFormAdminView.tdarkDyrlndirmFormalar') }}
      </h4>
      <div class="mb-3 ">
        {{ $t('vendorManagementForms.sizMxtlifFaliyytSahlriZrTdarklrinIlkinDyrlndirmFor') }}
      </div>
    </div>


    <div class="row">
      <div class="col-md-12">
        <div v-if="forms.length<1">
          <div class="card">
            <div class="card-body p-5 text-center">
              <feather
                type="info"
                size="50"
              />

              <h3>{{ $t('vendorManagementForms.tdarkTsdiqFormasMvcudDeyil') }}</h3>

              <p>
                {{ $t('vendorManagementForms.sizinTdarklrinIlkinDyrlndirilmsiNAnketSoruFormanzY') }}
              </p>

              <p>
                <a
                  v-b-modal.modal-form-create
                  class="btn btn-primary"
                  href="#"
                >{{ $t('vendorManagementForms.yeniForma2') }}</a>
              </p>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="card">
            <div class="card-header">
              <div class="row">
                <div class="col-md-9">
                  <select
                    v-model.number="formSectorFilter"
                    class="form-control"
                  >
                    <option :value="0">
                      {{ $t('vendorManagementPurchasesReports.btnFaliyytSahlri') }}
                    </option>
                    <option
                      v-for="s in sectorList"
                      :key="s.id"
                      :value="s.id"
                    >
                      {{ s.name }}
                    </option>
                  </select>
                </div>
                <div class="col-md-3">
                  <select
                    v-model="formStatusFilter"
                    class="form-control"
                  >
                    <option value="ALL">
                      {{ $t('vendorManagementPurchasesReports.hams') }}
                    </option>
                    <option value="DRAFT">
                      {{ $t('myRequest.qaralama') }}
                    </option>
                    <option value="READY">
                      {{ $t('vendorManagementForms.hazr') }}
                    </option>
                    <option value="ACTIVE">
                      {{ $t('changeAccount.aktiv') }}
                    </option>
                    <option value="ARCHIVE">
                      {{ $t('sector.arxiv') }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="card-body">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>{{ $t('companyFormEdit.formannAd') }}</th>
                    <th>{{ $t('header.profil') }}</th>
                    <th>{{ $t('vendorManagementPurchasesReports.faliyytSahsi') }}</th>
                    <th>{{ $t('vendorManagementForms.yaradlb') }}</th>
                    <th>{{ $t('vendorManagementForms.sonDyiiklik') }}</th>
                    <th>{{ $t('vendorManagementPurchasesReports.status') }}</th>
                    <th />
                  </tr>
                </thead>
                <tr v-if="filteredForms.length<1">
                  <td colspan="6">
                    <div class="alert alert-info">
                      {{ $t('companyForms.axtaraUyunDyrlndirmFormuTaplmad') }}
                    </div>
                  </td>
                </tr>
                <tr v-for="f in filteredForms">
                  <td style="max-width: 30%;">
                    {{ f.name }}
                  </td>
                  <td>
                    <ProfileTypeBadge
                      class="m-1 cursor-pointer"
                      :is-current="false"
                      :profile="f.profileType"
                      :badge-white="false"
                    />
                  </td>
                  <td>
                    <div
                      v-for=" s in f.sectors"
                      :class="{'font-weight-bold': s.sector.id === formSectorFilter }"
                    >
                      - {{ s.sector.name }}
                    </div>
                  </td>
                  <td style="white-space: nowrap">
                    {{ $t('vendorManagementForms.newDatefcreatetimeMomentddMmmYyyy' , {moment: getMoment(f.createTime)}) }}
                  </td>
                  <td style="white-space: nowrap">
                    {{ $t('vendorManagementForms.newDateflastupdatetimeMomentddMmmYyyy' , {moment:getMoment(f.lastUpdateTime)}) }}
                  </td>
                  <td>
                    <CompanyFormStatus :status="f.status" />
                  </td>
                  <td style="white-space: nowrap;">
                    <router-link :to="{name: 'vendorManagementFormManage', params:{id: f.id}}">
                      <feather type="tool" />
                    </router-link>
                    <router-link
                      :to="{name: 'vendorManagementFormEdit', params:{id: f.id}}"
                      class="ml-4"
                    >
                      <feather type="edit-2" />
                    </router-link>
                    <router-link
                      v-if="f.status==='ACTIVE'"
                      target="_blank"
                      :to="{name: 'vendorFormView', params:{id: f.id}}"
                      class="ml-4"
                    >
                      <feather type="eye" />
                    </router-link>
                  </td>
                </tr>
                <tr>
                  <td colspan="5">
                    <button
                      v-b-modal.modal-form-create
                      class="btn btn-sm btn-outline-primary ml-2 p-2"
                    >
                      <strong>+</strong> {{ $t('vendorManagementForms.yeniFormaYarat') }}
                    </button>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>


    <b-modal
      id="modal-form-create"
      centered
      :title="$t('vendorManagementForms.yeniForma')"
      class="theme-modal"
    >
      <form @submit.prevent="createForm">
        <div class="mb-3">
          <label>{{ $t('companyFormEdit.formannAd') }}</label>
          <div>
            <input
              v-model.trim="newForm.name"
              type="text"
              class="form-control"
              required
            >
          </div>
        </div>

        <div class="mb-3">
          <label>{{ $t('companyFormEdit.tyinat') }}</label>
          <div>
            <select
              v-model.trim="newForm.profileType"
              class="form-control"
              required
            >
              <option value="SUPPLIER">
                {{ $t('companyFormEdit.malVXidmtlrlBal') }}
              </option>
              <option value="LOGISTIC">
                {{ $t('companyFormEdit.logistiklrN') }}
              </option>
              <option value="TRUCK">
                {{ $t('companyFormEdit.trSahiblriN') }}
              </option>
            </select>
          </div>
        </div>

        <div
          v-if="newForm.profileType === 'SUPPLIER'"
          class="mb-3"
        >
          <label>{{ $t('companySearch.faliyytSahlri') }}</label>
          <div>
            <Multiselect
              v-model="newForm.sectors"
              name="form_sectors"
              :options="sectorList"
              :multiple="true"
              :label="$t('newTRKRequest.name')"
              track-by="id"
              :min="1"
              :taggable="false"
            />
          </div>
        </div>


        <div class="mb-3">
          <label>{{ $t('companyFormEdit.qeydlr') }} </label>
          <div>
            <textarea
              v-model.trim="newForm.description"
              type="text"
              class="form-control"
              required
            />
          </div>
        </div>

        <div class="mb-3">
          <button
            type="submit"
            class="btn btn-success"
          >
            {{ $t('companyFormEdit.yarat') }}
          </button>
        </div>
      </form>

      <template slot="modal-footer">
        <div class="text-warning">
          {{ $t('vendorManagementForms.daxilEtdiyinizMlumatlarTdrklrGstrilck') }}
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {mediaBase} from "@/repositories/Repository";
import {
  createForm,
  getFormList,
  handleErrors
} from "@/repositories/VendorManagementRepository";
import CompanyFormStatus from "@/pages/scc/vendorManagement/utils/CompanyFormStatus.vue";

import Multiselect from 'vue-multiselect'
import {getWorkingSectors} from "@/repositories/GeneralDataRepository";
import {getCompanyFormat, getProfileName} from "@/repositories/Utils";
import ProfileTypeBadge from "@/components/ProfileTypeBadge.vue";
import moment from "moment/moment";

export default {
  components: {
    ProfileTypeBadge,
    Multiselect, CompanyFormStatus,
  },
  data() {
    return {
      mediaBase: mediaBase,
      forms: [],
      formStatusFilter: 'ALL',
      formSectorFilter: 0,
      newForm: {
        name: '',
        profileType: '',
        description: '',
        sectors: []
      },
      sectorList: [],

    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
    }),

    filteredForms() {

      let forms = [];
      if (this.formStatusFilter === 'ALL') {
        forms = this.forms;
      } else {
        forms = this.forms.filter(f => f.status === this.formStatusFilter);
      }

      if (this.formSectorFilter > 0) {

        forms = forms.filter(f => f.sectors.filter(s => s.sector.id === this.formSectorFilter).length > 0);

      }

      return forms;

    },

  },
  mounted() {

    this.getFormList();

    getWorkingSectors(this.$i18n.locale).then(ws => {
      this.sectorList = ws.filter(s => s.parent === null);
    });

  },
  methods: {

    getMoment(time){
      moment.locale(this.$i18n.locale);
      return moment(new Date(time)).format('DD MMM YYYY')
    },
    getProfileName(keyword) {
      return getProfileName(keyword,this.i18n);
    },

    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },

    getFormList() {

      getFormList(this.token).then(list => {
        this.forms = list;
      })

    },

    createForm() {
      if (this.newForm.sectors.length < 1 && this.newForm.profileType === 'SUPPLIER') {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("enAziFlyytShs"),
          icon: 'error'
        });
        return;
      }
      let sectors = this.newForm.sectors.map(function (elem) {
        return elem.id;
      }).join(",");

      createForm(this.token, this.newForm.name, this.newForm.profileType, this.newForm.description, sectors).then(data => {

        if (data.code === 200) {

          this.$router.push({name: 'vendorManagementFormEdit', params: {id: data.id}});

        } else {
          handleErrors(this.$swal, data, null);
        }

      })
    },

  }

}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
